import { apiAService } from "../apiService";
import urlConfig from "../../../config/domain";
import { jwtToken } from "../../types/genericTypes";
import LoginService from "../login/loginService";

let pToken: jwtToken | null = LoginService.pToken,
  userID = pToken ? pToken.username : null;

//after redirect reinstate pToken with parsed jwt token
const pTokenCheck = (paramChk?: keyof jwtToken) => {
  if (!pToken) {
    pToken = LoginService.pToken;
    userID = pToken ? pToken.username : null;
  }
  return paramChk && pToken ? pToken[paramChk] : pToken;
};

export const getCountryList = async (Enum: any) => {
  return await apiAService({
    url: urlConfig.general.enumMaster,
    method: "POST",
    body: {
      "enumname": Enum
    }
  })
}
export const getDistinctBanklist = async () => {
  return await apiAService({
    url: urlConfig.general.distinctBanklist,
    method: "POST",
    // authType: "bearer",
  });
}
export const getBankListForIfsc = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.bankListForIfsc,
    method: "POST",
    // authType: "bearer",
    body: payload,
  });
}

export const getbankCities = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.bankCities,
    method: "POST",
    // authType: "bearer",
    body: payload,
  });
}

export const getbankBranch = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.bankBranch,
    method: "POST",
    // authType: "bearer",
    body: payload,
  });
}

export const checkPennyDrop = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.beneficiaryNamePichain,
    method: "POST",
    //authType: "pappid",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
}

export const saveBankDetails = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.saveBankDetails,
    method: "POST",
    // authType: "bearer",
    body: payload,
  });
}

export const getBankDetails = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.BankDetails,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
}

export const getFullAddress = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.fullAddressDetails,
    method: "POST",
    body: payload
  })
}
export const getArea = async (pincode: any) => {
  return await apiAService({
    url: urlConfig.general.areaDetails,
    method: "POST",
    body: {
      "pinCode": pincode
    }
  })
}
export const generateAccessTokenDetails = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.generateAccessToken,
    method: "POST",
    body: payload,
  })
}
export const getDocListFromDigilocker = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.getDocListFromDigilocker,
    method: "POST",
    body: payload,
  })
}
export const getSelectedDocument = async (payload: any) => {
  return await apiAService({
    url: urlConfig.general.getSelectedDocument,
    method: "POST",
    body: payload,
  })
}
export const AGenerateAccessToken = async (accessTokenObj: object) => {
  return await apiAService({
    url: urlConfig.general.generateAccessToken,
    body: accessTokenObj,
    method: "POST",
  });
}
export const AGetDocListFromDigilocker = async (digilockerObj: object) => {
  return await apiAService({
    url: urlConfig.general.getDocListFromDigilocker,
    body: digilockerObj,
    method: "POST",
  });
}
// export const getSelectedDocument = async( digilockerObj: object) => {
//   return await apiAService({
//           url: urlConfig.general.getSelectedDocument,
//           body: digilockerObj,
//           method: "POST",
//       });
// }

export const extractCheque = async (payload: object) => {
  return await apiAService({
    url: urlConfig.general.getExtractCheque,
    method: "POST",
    authType: "pappid",
    body: payload,
  });
}
export const getExtractaadhaar = async (payload: object) => {
  return await apiAService({
    url: urlConfig.general.getExtractaadhaarDetails,
    method: "POST",
    authType: "pappid",
    body: payload,
  });
}
export const getExtractVoterID = async (payload: object) => {
  return await apiAService({
    url: urlConfig.general.getExtractVoterIDDetails,
    method: "POST",
    authType: "pappid",
    body: payload,
  });
}

export const getExtractPassport = async (payload: object) => {
  return await apiAService({
    url: urlConfig.general.getExtractPassportDetails,
    method: "POST",
    authType: "pappid",
    body: payload,
  });
}
export const getExtractDL = async (payload: object) => {
  return await apiAService({
    url: urlConfig.general.getExtractDLDetails,
    method: "POST",
    authType: "pappid",
    body: payload,
  });
}
export const maskedAadhaar = async (payload: object) => {
  return await apiAService({
    url: urlConfig.general.maskAadhaarLDetails,
    method: "POST",
    authType: "pappid",
    body: payload,
  });
}
export const getDigiLockerDetails = async (reqObj: object) => {
  return await apiAService({
    url: urlConfig.profile.fetchDigiLockerDetails,
    method: "POST",
    authType: "bearer",
    body: reqObj,
  });
}
export const getIPVOTP = async () => {
  return await apiAService({
    url: urlConfig.profile.GetIPVOTP,
    method: "GET",
    authType: "bearer"
  });
}